export default {
  booking: () => import("/home/runner/work/spa/spa/layouts/booking.vue"),
  default: () => import("/home/runner/work/spa/spa/layouts/default.vue"),
  "transparent-nav": () => import("/home/runner/work/spa/spa/layouts/transparent-nav.vue")
}